// src/pages/produccion/ConfigKgPorCarro.jsx
import { useEffect, useState } from 'react';
import api from '../../services/api';

export default function ConfigKgPorCarro() {
  const [filas, setFilas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [guardandoReceta, setGuardandoReceta] = useState(null);
  const [mensaje, setMensaje] = useState(null);

  async function cargar() {
    try {
      setCargando(true);
      const res = await api.get('/api/produccion/config/kg-por-carro');
      setFilas(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, []);

  function handleCambiar(receta, valor) {
    setFilas((prev) => prev.map((f) => (f.receta === receta ? { ...f, kg_por_carro: valor } : f)));
  }

  async function handleGuardar(receta) {
    const fila = filas.find((f) => f.receta === receta);
    try {
      setGuardandoReceta(receta);
      await api.put(`/api/produccion/config/kg-por-carro/${encodeURIComponent(receta)}`, {
        kg_por_carro: fila.kg_por_carro,
      });
      setMensaje({ tipo: 'ok', texto: `✓ ${receta} actualizado.` });
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: `No se pudo guardar ${receta}.` });
    } finally {
      setGuardandoReceta(null);
    }
  }

  if (cargando) return <div style={styles.contenedor}>Cargando...</div>;

  return (
    <div style={styles.contenedor}>
      <h1 style={styles.titulo}>Kg por Carro (por receta)</h1>
      <p style={styles.subtitulo}>
        Usado para auto-calcular Kg Producidos en la Captura Diaria de Producción. Fuente original: hoja "Mz".
      </p>

      {mensaje && (
        <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>
          {mensaje.texto}
        </div>
      )}

      <div style={styles.tarjeta}>
        <table style={styles.tabla}>
          <thead>
            <tr>
              <th style={styles.th}>Receta</th>
              <th style={styles.th}>Kg por Carro</th>
              <th style={styles.th}></th>
            </tr>
          </thead>
          <tbody>
            {filas.map((f) => (
              <tr key={f.receta}>
                <td style={styles.td}>{f.receta}</td>
                <td style={styles.td}>
                  <input
                    type="number"
                    step="0.001"
                    value={f.kg_por_carro}
                    onChange={(e) => handleCambiar(f.receta, e.target.value)}
                    style={styles.input}
                  />
                </td>
                <td style={styles.td}>
                  <button
                    onClick={() => handleGuardar(f.receta)}
                    disabled={guardandoReceta === f.receta}
                    style={styles.botonGuardar}
                  >
                    {guardandoReceta === f.receta ? 'Guardando...' : 'Guardar'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42', maxWidth: '560px' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '4px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', marginBottom: '20px' },
  mensaje: { fontSize: '13px', marginBottom: '14px', fontWeight: 600 },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '10px 16px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)' },
  tabla: { width: '100%', borderCollapse: 'collapse', fontSize: '13px' },
  th: { textAlign: 'left', padding: '8px 6px', borderBottom: '2px solid #E6DDD2', color: '#6E4F80', fontWeight: 600, fontSize: '11px', textTransform: 'uppercase' },
  td: { padding: '6px', borderBottom: '1px solid #F0E9E0' },
  input: { width: '90px', padding: '5px 8px', fontSize: '13px', border: '1px solid #E6DDD2', borderRadius: '6px', fontFamily: 'Inter, sans-serif' },
  botonGuardar: { padding: '5px 12px', fontSize: '11px', fontWeight: 600, color: '#6E4F80', background: '#EFE9F3', border: '1px solid #A98BB8', borderRadius: '6px', cursor: 'pointer' },
};